import { render, staticRenderFns } from "./QuoteTypes.vue?vue&type=template&id=2fcc2ff4"
import script from "./QuoteTypes.vue?vue&type=script&lang=js"
export * from "./QuoteTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports